import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    staticClass: "tenant",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VOverlay, {
    attrs: {
      "value": !_vm.lclModel.id && _vm.isCreatingNewTenant
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "10",
      "size": "90",
      "rotate": "-90"
    }
  })], 1), _vm.tenantSwitchPrompt ? _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.tenant.movePrompt.title'),
      "open": _vm.tenantSwitchPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('accMgmt.tenant.movePrompt.confirm'),
        color: 'danger',
        emit: 'switch-tenant'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.tenantParentId = _vm.referenceTenant.parentId;
        _vm.tenantSwitchPrompt = false;
      },
      "switch-tenant": function ($event) {
        _vm.tenantSwitchPrompt = false;
        _vm.tenantParentId = _vm.tenantSwitchId;
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('accMgmt.tenant.movePrompt.text', {
        tenantName: _vm.newTenantParentName
      }))
    }
  })]) : _vm._e(), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [!_vm.lclModel.id ? _c(VCol, {
    staticClass: "mt-0 pt-0 pr-0 mr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('h4', {
    staticClass: "pt-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.tenant')) + ":")])]) : _vm._e(), _c(VCol, {
    staticClass: "mt-0 pt-0 pl-0 ml-0",
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [!_vm.lclModel.id && _vm.tenantDetails && _vm.tenantDetails.ancestors.length ? _c(VBreadcrumbs, {
    staticClass: "px-2",
    attrs: {
      "items": _vm.tenantDetails.ancestors,
      "large": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VBreadcrumbsItem, {
          attrs: {
            "disabled": !item.disabled
          }
        }, [_vm._v("\n            " + _vm._s(item.name.toUpperCase()) + "\n          ")])];
      }
    }], null, false, 1663096046)
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": _vm.lclModel.id && _vm.lclModel.parentId && _vm.tenants.length ? 6 : 12
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "label": "Name",
      "required": "",
      "data-cy": "account_input_name"
    },
    model: {
      value: _vm.lclModel.name,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel, "name", $$v);
      },
      expression: "lclModel.name"
    }
  })], 1), _vm.lclModel.id && _vm.lclModel.parentId && _vm.tenants.length ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": _vm.lclModel.id ? 6 : 12
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.tenantParentSelection'),
      "items": _vm.tenants,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "data-cy": "select_tenant_parent"
    },
    on: {
      "change": _vm.promptSelectedTenant
    },
    model: {
      value: _vm.tenantParentId,
      callback: function ($$v) {
        _vm.tenantParentId = $$v;
      },
      expression: "tenantParentId"
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "py-1",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.description'),
      "rows": "3",
      "outlined": "",
      "hide-details": "",
      "data-cy": "input_description"
    },
    model: {
      value: _vm.lclModel.data.description,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data, "description", $$v);
      },
      expression: "lclModel.data.description"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "9"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "label": "Service Builder URL",
      "data-cy": "input_service_builder_url"
    },
    model: {
      value: _vm.lclModel.data.serviceBuilderUrl,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data, "serviceBuilderUrl", $$v);
      },
      expression: "lclModel.data.serviceBuilderUrl"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "3"
    }
  }, [_c('core-button', {
    attrs: {
      "disabled": !_vm.lclModel.data.serviceBuilderUrl,
      "prepend-icon": "fa-tachometer-alt-fast",
      "color": _vm.color,
      "data-cy": "button_open_link"
    },
    on: {
      "click": _vm.openLink
    }
  })], 1), _vm.serviceBuilderParams ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "accordion": ""
    },
    model: {
      value: _vm.serviceBuilderPanel,
      callback: function ($$v) {
        _vm.serviceBuilderPanel = $$v;
      },
      expression: "serviceBuilderPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.serviceBuilder')))]), _c(VExpansionPanelContent, [_c('pre', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_vm._v(_vm._s(JSON.stringify(_vm.serviceBuilderParams, null, 2)))])])], 1)], 1)], 1) : _vm._e(), _c(VCol, {
    staticClass: "py-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.domainMapping')))]), _c('settings-theme-domains', {
    key: _vm.lclModel.id,
    attrs: {
      "domains": _vm.tenantDomains,
      "tenantId": _vm.lclModel.id
    },
    on: {
      "update": _vm.updateDomains
    }
  })], 1), _c(VCol, [_c('h4', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.email.server.title')))]), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    class: _vm.requiredEmailFieldsAreEmpty ? '' : 'required',
    attrs: {
      "placeholder": _vm.lclModel.data.email.defaults.emailAddress,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.system.email.server.email'),
      "rules": [_vm.validateEmailSettings],
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.delete'),
            "prepend-icon": "fa-trash-alt",
            "color": _vm.color
          },
          on: {
            "click": _vm.clearEmailSettings
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.lclModel.data.email.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "emailAddress", $$v);
      },
      expression: "lclModel.data.email.emailAddress"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    class: _vm.requiredEmailFieldsAreEmpty ? '' : 'required',
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.email.server.host'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.validateEmailSettings],
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.serverAddress,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "serverAddress", $$v);
      },
      expression: "lclModel.data.email.serverAddress"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    class: _vm.requiredEmailFieldsAreEmpty ? '' : 'required',
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.email.server.port'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": [_vm.validateEmailSettings],
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.serverPort,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "serverPort", $$v);
      },
      expression: "lclModel.data.email.serverPort"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.email.server.user'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "name": "emailServerUser",
      "autocomplete": "new-password",
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.serverUser,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "serverUser", $$v);
      },
      expression: "lclModel.data.email.serverUser"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.email.server.password'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autocomplete": "new-password",
      "name": "emailServerPassword",
      "type": "password",
      "hide-details": ""
    },
    on: {
      "keyup": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.serverPassword,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "serverPassword", $$v);
      },
      expression: "lclModel.data.email.serverPassword"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_vm.lclModel.data.email.secure === undefined ? _c(VSwitch, {
    staticStyle: {
      "opacity": "0.4"
    },
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "secure",
      "input-value": false,
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": e => {
        _vm.updateEmailSwitchToggle(e, 'secure');
      }
    }
  }) : _c(VSwitch, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "secure",
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.secure,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "secure", $$v);
      },
      expression: "lclModel.data.email.secure"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_vm.lclModel.data.email.ignoreTLS === undefined ? _c(VSwitch, {
    staticStyle: {
      "opacity": "0.4"
    },
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "ignoreTLS",
      "input-value": false,
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": e => {
        _vm.updateEmailSwitchToggle(e, 'ignoreTLS');
      }
    }
  }) : _c(VSwitch, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "ignoreTLS",
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.ignoreTLS,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "ignoreTLS", $$v);
      },
      expression: "lclModel.data.email.ignoreTLS"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3"
    }
  }, [_vm.lclModel.data.email.rejectUnauthorized === undefined ? _c(VSwitch, {
    staticStyle: {
      "opacity": "0.4"
    },
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "rejectUnauthorized",
      "input-value": false,
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": e => {
        _vm.updateEmailSwitchToggle(e, 'rejectUnauthorized');
      }
    }
  }) : _c(VSwitch, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "label": "rejectUnauthorized",
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": _vm.revalidateForm
    },
    model: {
      value: _vm.lclModel.data.email.rejectUnauthorized,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.email, "rejectUnauthorized", $$v);
      },
      expression: "lclModel.data.email.rejectUnauthorized"
    }
  })], 1)], 1)], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.header')))])])], 1), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.upperLowerCase'),
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.data.passwordPolicy.upperAndLowercase,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.passwordPolicy, "upperAndLowercase", $$v);
      },
      expression: "lclModel.data.passwordPolicy.upperAndLowercase"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.numbers'),
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.data.passwordPolicy.numbers,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.passwordPolicy, "numbers", $$v);
      },
      expression: "lclModel.data.passwordPolicy.numbers"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.specialCharacters'),
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.data.passwordPolicy.specialCharacters,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.passwordPolicy, "specialCharacters", $$v);
      },
      expression: "lclModel.data.passwordPolicy.specialCharacters"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.passwordLengthRule,
      "label": _vm.$i18n_t('accMgmt.user.accUserPasswordPolicy.length'),
      "type": "number",
      "autocomplete": "off",
      "hide-details": "auto"
    },
    model: {
      value: _vm.lclModel.data.passwordPolicy.length,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.data.passwordPolicy, "length", $$v);
      },
      expression: "lclModel.data.passwordPolicy.length"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.properties')))])])], 1), _vm._l(_vm.lclModel.data.userDefaultProperties, function (key, i) {
    return _c(VRow, {
      key: `userProperties-${i}`,
      staticStyle: {
        "min-width": "0"
      },
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "py-1",
      attrs: {
        "cols": "12"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('accMgmt.user.propertyKey'),
        "autocomplete": "off",
        "hide-details": ""
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            attrs: {
              "title": _vm.$i18n_t('Common.addNew'),
              "prepend-icon": "fa-plus",
              "color": _vm.color
            },
            on: {
              "click": function ($event) {
                return _vm.addUserProperty();
              }
            }
          }), _c('core-button', {
            attrs: {
              "title": _vm.$i18n_t('Common.delete'),
              "prepend-icon": "fa-trash-alt",
              "color": _vm.color
            },
            on: {
              "click": function ($event) {
                return _vm.removeUserProperty(i);
              }
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: _vm.lclModel.data.userDefaultProperties[i],
        callback: function ($$v) {
          _vm.$set(_vm.lclModel.data.userDefaultProperties, i, $$v);
        },
        expression: "lclModel.data.userDefaultProperties[i]"
      }
    }), _c('p', {
      staticClass: "card-description mt-2"
    }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.titlePropertyFieldHint')))])], 1)], 1);
  }), _vm.lclModel.id ? _c(VRow, [_c(VExpansionPanels, {
    staticClass: "my-4 pa-0",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.panel,
      callback: function ($$v) {
        _vm.panel = $$v;
      },
      expression: "panel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.tenantMoreDetails')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "px-4"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.updatedAt'),
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.tenantDates.updatedAt,
      callback: function ($$v) {
        _vm.$set(_vm.tenantDates, "updatedAt", $$v);
      },
      expression: "tenantDates.updatedAt"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.createdAt'),
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.tenantDates.createdAt,
      callback: function ($$v) {
        _vm.$set(_vm.tenantDates, "createdAt", $$v);
      },
      expression: "tenantDates.createdAt"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.hierarchyLevel'),
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.hierarchyLevel,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel, "hierarchyLevel", $$v);
      },
      expression: "lclModel.hierarchyLevel"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": "ID",
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.id,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel, "id", $$v);
      },
      expression: "lclModel.id"
    }
  })], 1)], 1), _c(VRow, {
    staticClass: "px-4"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.ownTwinCount'),
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.tenantDetails.twinCount.own,
      callback: function ($$v) {
        _vm.$set(_vm.tenantDetails.twinCount, "own", $$v);
      },
      expression: "tenantDetails.twinCount.own"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.tenant.subTwinCount'),
      "color": _vm.color,
      "readonly": "",
      "disabled": "",
      "hide-details": ""
    },
    model: {
      value: _vm.tenantDetails.twinCount.sub,
      callback: function ($$v) {
        _vm.$set(_vm.tenantDetails.twinCount, "sub", $$v);
      },
      expression: "tenantDetails.twinCount.sub"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };